import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { getAuthHeader, getUserInfo } from '../utils/tokenManager';

const PartnerManagement = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [bankOptions, setBankOptions] = useState([]);
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [filterName, setFilterName] = useState('');
  const [filterEmail, setFilterEmail] = useState('');
  const [filterUse, setFilterUse] = useState('all');
  const [form, setForm] = useState({
    거래처명: '',
    대표이메일: '',
    대표자: '',
    담당자: '',
    국가번호: '',
    대표전화: '',
    기본주소: '',
    우편번호: '',
    상세주소: '',
    은행: '',
    은행코드: '',
    계좌번호: '',
    예금주: '',
    사용여부: true,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError('');
        const { companyNo } = getUserInfo() || {};
        const payload = {
          Table1: [
            { 컬럼명: '@업체번호', 값: String(companyNo) },
            { 컬럼명: '@사용여부1', 값: true },
            { 컬럼명: '@사용여부2', 값: true },
          ],
        };
        const url = 'https://trpliveapi1.tripbox.co.kr/ERP/GetDataSet?procedureName=DBO.CW_S_%EA%B3%B5%EA%B8%89%EA%B1%B0%EB%9E%98%EC%B2%98';
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
          body: JSON.stringify(payload),
        });
        if (!res.ok) throw new Error('Failed to load');
        const data = await res.json();
        setRows(Array.isArray(data?.table) ? data.table : []);
      } catch (e) {
        setError('데이터를 불러오지 못했습니다.');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const openEdit = async (row) => {
    setEditRow(row);
    setForm({
      거래처명: row?.거래처명 ?? '',
      대표이메일: row?.대표이메일 ?? '',
      대표자: row?.대표자명 ?? '',
      담당자: row?.담당자명 ?? '',
      국가번호: row?.국가번호 ?? '',
      대표전화: row?.대표전화 ?? '',
      기본주소: row?.기본주소 ?? '',
      우편번호: row?.우편번호 ?? '',
      상세주소: row?.상세주소 ?? '',
      은행: row?.은행명 ?? '',
      은행코드: row?.은행코드 ?? '',
      계좌번호: row?.계좌번호 ?? '',
      예금주: row?.예금주 ?? '',
      사용여부: !!row?.사용여부,
    });
    try {
      const { companyNo } = getUserInfo() || {};
      const payload = {
        Table1: [
          { 컬럼명: '@종류', 값: 'CW수납은행', 리스트값: null },
          { 컬럼명: '@공급업체번호', 값: String(companyNo ?? '1'), 리스트값: null },
        ],
      };
      const url = 'https://trpliveapi1.tripbox.co.kr/ERP/GetDataSet?procedureName=DBO.RCT_S_%EC%88%98%EB%8F%99%EC%BD%94%EB%93%9C';
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
        body: JSON.stringify(payload),
      });
      if (res.ok) {
        const data = await res.json();
        const list = Array.isArray(data?.table) ? data.table : [];
        setBankOptions(list.map(x => ({ code: x?.코드 ?? '', name: x?.코드명 ?? '' })));
      } else {
        setBankOptions([]);
      }
    } catch (e) {
      setBankOptions([]);
    }
    setIsEditOpen(true);
  };

  const closeEdit = () => {
    setIsEditOpen(false);
    setEditRow(null);
  };

  const openCreate = () => {
    setForm({
      거래처명: '',
      대표이메일: '',
      대표자: '',
      담당자: '',
      국가번호: '',
      대표전화: '',
      기본주소: '',
      우편번호: '',
      상세주소: '',
      은행: '',
      은행코드: '',
      계좌번호: '',
      예금주: '',
      사용여부: true,
    });
    setIsCreateOpen(true);
  };

  const extractApiErrorMessage = (payload) => {
    if (!payload || typeof payload !== 'object') return '';
    const direct =
      payload?.메시지 ||
      payload?.message ||
      payload?.MESSAGE ||
      payload?.오류 ||
      payload?.error ||
      payload?.ErrorMessage ||
      '';
    if (direct) return String(direct);
    const first =
      payload?.table?.[0] ||
      payload?.table1?.[0] ||
      payload?.Table?.[0] ||
      payload?.Table1?.[0] ||
      payload?.result?.[0] ||
      null;
    if (first && typeof first === 'object') {
      return String(
        first?.메시지 ||
          first?.message ||
          first?.MESSAGE ||
          first?.오류 ||
          first?.error ||
          first?.상태 ||
          ''
      );
    }
    return '';
  };

  const handleCreate = async () => {
    try {
      const name = String(form.거래처명 ?? '').trim();
      const email = String(form.대표이메일 ?? '').trim();
      const manager = String(form.담당자 ?? '').trim();
      if (!name) {
        Modal.warning({ title: '입력 확인', content: '거래처명을 입력해주세요.' });
        return;
      }
      if (!email) {
        Modal.warning({ title: '입력 확인', content: '이메일을 입력해주세요.' });
        return;
      }
      const { companyNo, userNo } = getUserInfo() || {};
      const payload = {
        Table1: [
          { 컬럼명: '@업체번호', 값: String(companyNo ?? '') },
          { 컬럼명: '@거래처명', 값: name },
          { 컬럼명: '@담당자명', 값: manager },
          { 컬럼명: '@이메일', 값: email },
          { 컬럼명: '@변경자', 값: String(userNo ?? '') },
        ],
      };
      const url = 'https://trpliveapi1.tripbox.co.kr/ERP/GetDataSet?procedureName=DBO.WSP_T_%EA%B3%B5%EA%B8%89%EA%B1%B0%EB%9E%98%EC%B2%98_%EB%93%B1%EB%A1%9D';
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
        body: JSON.stringify(payload),
      });

      let saveData = null;
      try {
        saveData = await res.json();
      } catch (_) {
        saveData = null;
      }

      if (!res.ok) {
        const serverMsg = extractApiErrorMessage(saveData);
        Modal.error({
          title: '신규 추가 실패',
          content: serverMsg || `저장에 실패했습니다. (HTTP ${res.status})`,
        });
        return;
      }

      const statusText = saveData?.table?.[0]?.상태 || saveData?.Table?.[0]?.상태 || '';
      if (statusText && /실패|오류|에러|error|fail/i.test(String(statusText))) {
        Modal.error({
          title: '신규 추가 실패',
          content: String(statusText),
        });
        return;
      }

      Modal.success({
        title: '신규 추가 완료',
        content: statusText ? `저장되었습니다. (${statusText})` : '공급사가 등록되었습니다.',
      });

      const reloadUrl = 'https://trpliveapi1.tripbox.co.kr/ERP/GetDataSet?procedureName=DBO.CW_S_%EA%B3%B5%EA%B8%89%EA%B1%B0%EB%9E%98%EC%B2%98';
      const reloadPayload = {
        Table1: [
          { 컬럼명: '@업체번호', 값: String(companyNo ?? '') },
          { 컬럼명: '@사용여부1', 값: true },
          { 컬럼명: '@사용여부2', 값: true },
        ],
      };
      const r2 = await fetch(reloadUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
        body: JSON.stringify(reloadPayload),
      });
      if (r2.ok) {
        const data = await r2.json();
        setRows(Array.isArray(data?.table) ? data.table : []);
      }
      setIsCreateOpen(false);
    } catch (e) {
      Modal.error({
        title: '신규 추가 실패',
        content: e?.message ? String(e.message) : '저장에 실패했습니다.',
      });
    }
  };

  const closeCreate = () => {
    setIsCreateOpen(false);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleBankChange = (e) => {
    const name = e.target.value;
    const found = bankOptions.find(b => b.name === name);
    setForm((prev) => ({
      ...prev,
      은행: name,
      은행코드: found?.code || '',
    }));
  };

  const handleSave = async () => {
    try {
      if (!editRow) return;
      const { companyNo, userNo } = getUserInfo() || {};
      const payload = {
        Table1: [
          { 컬럼명: '@공급업체번호', 값: String(companyNo ?? '') },
          { 컬럼명: '@등록자', 값: String(userNo ?? '') },
          { 컬럼명: '@거래처번호', 값: Number(editRow?.거래처번호) },
          { 컬럼명: '@신규업체명', 값: form.거래처명 ?? '' },
          { 컬럼명: '@이메일', 값: form.대표이메일 ?? '' },
          { 컬럼명: '@대표자', 값: form.대표자 ?? '' },
          { 컬럼명: '@담당자', 값: form.담당자 ?? '' },
          { 컬럼명: '@기본주소', 값: form.기본주소 ?? '' },
          { 컬럼명: '@상세주소', 값: form.상세주소 ?? '' },
          { 컬럼명: '@우편번호', 값: form.우편번호 ?? '' },
          { 컬럼명: '@국가번호', 값: form.국가번호 ?? '' },
          { 컬럼명: '@대표전화', 값: form.대표전화 ?? '' },
          { 컬럼명: '@사용여부', 값: !!form.사용여부 },
          { 컬럼명: '@은행코드', 값: form.은행코드 ?? '' },
          { 컬럼명: '@계좌번호', 값: form.계좌번호 ?? '' },
          { 컬럼명: '@예금주', 값: form.예금주 ?? '' },
          { 컬럼명: '@은행명', 값: form.은행 ?? '' },
        ],
      };
      const url = 'https://trpliveapi1.tripbox.co.kr/ERP/GetDataSet?procedureName=DBO.CW_S_%EA%B3%B5%EA%B8%89%EA%B1%B0%EB%9E%98%EC%B2%98%EC%A0%95%EB%B3%B4%EC%88%98%EC%A0%95';
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        window.alert('저장에 실패했습니다.');
        return;
      }
      const saveData = await res.json();
      const saved = Array.isArray(saveData?.table) && saveData.table.length > 0;
      if (saved) {
        const statusText = saveData.table[0]?.상태;
        window.alert(statusText ? `저장되었습니다. (${statusText})` : '저장되었습니다.');
      } else {
        window.alert('저장에 실패했습니다.');
      }
      // Refresh list
      const reloadUrl = 'https://trpliveapi1.tripbox.co.kr/ERP/GetDataSet?procedureName=DBO.CW_S_%EA%B3%B5%EA%B8%89%EA%B1%B0%EB%9E%98%EC%B2%98';
      const reloadPayload = {
        Table1: [
          { 컬럼명: '@업체번호', 값: String(companyNo ?? '') },
          { 컬럼명: '@사용여부1', 값: true },
          { 컬럼명: '@사용여부2', 값: true },
        ],
      };
      const r2 = await fetch(reloadUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
        body: JSON.stringify(reloadPayload),
      });
      if (r2.ok) {
        const data = await r2.json();
        setRows(Array.isArray(data?.table) ? data.table : []);
      }
      closeEdit();
    } catch (e) {
      window.alert('저장에 실패했습니다.');
    }
  };

  const filteredRows = React.useMemo(() => {
    return rows.filter(r => {
      const nameOk = filterName ? String(r?.거래처명 || '').toLowerCase().includes(filterName.toLowerCase()) : true;
      const emailOk = filterEmail ? String(r?.대표이메일 || '').toLowerCase().includes(filterEmail.toLowerCase()) : true;
      const useOk = filterUse === 'all' ? true : (filterUse === 'use' ? !!r?.사용여부 : !r?.사용여부);
      return nameOk && emailOk && useOk;
    });
  }, [rows, filterName, filterEmail, filterUse]);

  return (
    <div className="p-4 space-y-4">
      <div className="rounded-2xl bg-white p-5">
      <div className="flex items-center justify-between mb-3">
        <h1 className="text-[17px] font-bold text-gray-900">공급사 관리</h1>
        <button
          type="button"
          className="h-9 rounded-lg px-3.5 text-sm font-semibold bg-primary-600 text-white hover:bg-primary-700"
          onClick={openCreate}
        >
          신규 추가
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-2">
        <input
          value={filterName}
          onChange={(e) => setFilterName(e.target.value)}
          className="w-full h-9 rounded-lg border border-gray-300 bg-white px-2.5 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 outline-none"
          placeholder="공급사명 검색"
        />
        <input
          value={filterEmail}
          onChange={(e) => setFilterEmail(e.target.value)}
          className="w-full h-9 rounded-lg border border-gray-300 bg-white px-2.5 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 outline-none"
          placeholder="대표이메일 검색"
        />
        <select
          value={filterUse}
          onChange={(e) => setFilterUse(e.target.value)}
          className="w-full h-9 rounded-lg border border-gray-300 bg-white px-2.5 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 outline-none"
        >
          <option value="all">사용여부(전체)</option>
          <option value="use">사용</option>
          <option value="not">미사용</option>
        </select>
        <div className="flex gap-2">
          <button
            type="button"
            className="h-9 rounded-lg px-3.5 text-sm font-semibold border border-gray-300 bg-white hover:bg-gray-50 w-full"
            onClick={() => { setFilterName(''); setFilterEmail(''); setFilterUse('all'); }}
          >
            초기화
          </button>
        </div>
      </div>
      </div>
      {loading && (
        <div className="rounded-2xl bg-white p-5 py-16 text-center text-sm text-gray-500">로딩 중...</div>
      )}
      {!loading && error && (
        <div className="rounded-2xl bg-white p-5 py-16 text-center text-sm text-red-600">{error}</div>
      )}
      {!loading && !error && (
        <div className="overflow-auto rounded-2xl bg-white p-5">
          <table className="min-w-full">
            <thead>
              <tr>
                <th className="h-10 bg-gray-100 px-3 text-left text-[13px] font-medium text-gray-500 first:rounded-l-lg last:rounded-r-lg">거래처명</th>
                <th className="h-10 bg-gray-100 px-3 text-left text-[13px] font-medium text-gray-500 first:rounded-l-lg last:rounded-r-lg">대표자명</th>
                <th className="h-10 bg-gray-100 px-3 text-left text-[13px] font-medium text-gray-500 first:rounded-l-lg last:rounded-r-lg">담당자명</th>
                <th className="h-10 bg-gray-100 px-3 text-left text-[13px] font-medium text-gray-500 first:rounded-l-lg last:rounded-r-lg">대표이메일</th>
                <th className="h-10 bg-gray-100 px-3 text-left text-[13px] font-medium text-gray-500 first:rounded-l-lg last:rounded-r-lg">대표전화</th>
                <th className="h-10 bg-gray-100 px-3 text-left text-[13px] font-medium text-gray-500 first:rounded-l-lg last:rounded-r-lg">사용여부</th>
              </tr>
            </thead>
            <tbody className="bg-white">
              {filteredRows.map((r, idx) => (
                <tr key={idx} className="group border-b border-gray-200 hover:bg-gray-50">
                  <td className="px-3 py-3 text-sm text-gray-900 whitespace-nowrap">{r?.거래처명 ?? ''}</td>
                  <td className="px-3 py-3 text-sm text-gray-700 whitespace-nowrap">{r?.대표자명 ?? ''}</td>
                  <td className="px-3 py-3 text-sm text-gray-700 whitespace-nowrap">{r?.담당자명 ?? ''}</td>
                  <td className="px-3 py-3 text-sm text-gray-700 whitespace-nowrap">{r?.대표이메일 ?? ''}</td>
                  <td className="px-3 py-3 text-sm text-gray-700 whitespace-nowrap">{r?.대표전화 ?? ''}</td>
                  <td className="px-3 py-3 text-sm whitespace-nowrap relative">
                    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold transition-opacity ${r?.사용여부 ? 'bg-green-50 text-green-700' : 'bg-gray-100 text-gray-600'} group-hover:opacity-0`}>
                      {r?.사용여부 ? '사용' : '미사용'}
                    </span>
                    <button
                      type="button"
                      className="absolute inset-0 m-auto h-8 w-16 px-0 py-0 text-sm font-semibold rounded-lg border border-gray-300 bg-white hover:bg-gray-50 opacity-0 group-hover:opacity-100 transition-opacity"
                      onClick={() => openEdit(r)}
                      style={{ width: '56px', height: '28px' }}
                    >
                      편집
                    </button>
                  </td>
                </tr>
              ))}
              {filteredRows.length === 0 && (
                <tr>
                  <td colSpan={6} className="py-16 text-center text-sm text-gray-500">표시할 데이터가 없습니다.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {isEditOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="absolute inset-0 bg-black/40" onClick={closeEdit} />
          <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-3xl mx-4">
            <div className="px-6 pt-5 pb-3">
              <div className="text-[17px] font-bold">거래처 편집</div>
            </div>
            <div className="px-6 py-4 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-[13px] font-semibold text-gray-600 mb-1">거래처명</label>
                <input name="거래처명" value={form.거래처명} onChange={handleChange} className="w-full h-9 rounded-lg border border-gray-300 bg-white px-2.5 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 outline-none" />
              </div>
              <div>
                <label className="block text-[13px] font-semibold text-gray-600 mb-1">대표 이메일</label>
                <input name="대표이메일" value={form.대표이메일} onChange={handleChange} className="w-full h-9 rounded-lg border border-gray-300 bg-white px-2.5 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 outline-none" />
              </div>
              <div>
                <label className="block text-[13px] font-semibold text-gray-600 mb-1">대표자</label>
                <input name="대표자" value={form.대표자} onChange={handleChange} className="w-full h-9 rounded-lg border border-gray-300 bg-white px-2.5 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 outline-none" />
              </div>
              <div>
                <label className="block text-[13px] font-semibold text-gray-600 mb-1">국가번호</label>
                <input name="국가번호" value={form.국가번호} onChange={handleChange} className="w-full h-9 rounded-lg border border-gray-300 bg-white px-2.5 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 outline-none" placeholder="예: +82" />
              </div>
              <div>
                <label className="block text-[13px] font-semibold text-gray-600 mb-1">대표전화</label>
                <input name="대표전화" value={form.대표전화} onChange={handleChange} className="w-full h-9 rounded-lg border border-gray-300 bg-white px-2.5 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 outline-none" />
              </div>
              <div>
                <label className="block text-[13px] font-semibold text-gray-600 mb-1">기본주소</label>
                <input name="기본주소" value={form.기본주소} onChange={handleChange} className="w-full h-9 rounded-lg border border-gray-300 bg-white px-2.5 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 outline-none" />
              </div>
              <div>
                <label className="block text-[13px] font-semibold text-gray-600 mb-1">우편번호</label>
                <input name="우편번호" value={form.우편번호} onChange={handleChange} className="w-full h-9 rounded-lg border border-gray-300 bg-white px-2.5 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 outline-none" />
              </div>
              <div>
                <label className="block text-[13px] font-semibold text-gray-600 mb-1">상세주소</label>
                <input name="상세주소" value={form.상세주소} onChange={handleChange} className="w-full h-9 rounded-lg border border-gray-300 bg-white px-2.5 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 outline-none" />
              </div>
              <div>
                <label className="block text-[13px] font-semibold text-gray-600 mb-1">은행</label>
                <select name="은행" value={form.은행} onChange={handleBankChange} className="w-full h-9 rounded-lg border border-gray-300 bg-white px-2.5 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 outline-none">
                  <option value="">선택</option>
                  {bankOptions.map((b) => (
                    <option key={`${b.code}-${b.name}`} value={b.name}>{b.name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-[13px] font-semibold text-gray-600 mb-1">계좌번호</label>
                <input name="계좌번호" value={form.계좌번호} onChange={handleChange} className="w-full h-9 rounded-lg border border-gray-300 bg-white px-2.5 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 outline-none" />
              </div>
              <div>
                <label className="block text-[13px] font-semibold text-gray-600 mb-1">예금주</label>
                <input name="예금주" value={form.예금주} onChange={handleChange} className="w-full h-9 rounded-lg border border-gray-300 bg-white px-2.5 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 outline-none" />
              </div>
              <div className="flex items-center gap-2">
                <input id="useYn" type="checkbox" name="사용여부" checked={!!form.사용여부} onChange={handleChange} className="h-4 w-4" />
                <label htmlFor="useYn" className="text-sm text-gray-700">사용여부</label>
              </div>
            </div>
            <div className="px-6 pb-5 pt-3 flex justify-end gap-2">
              <button type="button" className="h-9 rounded-lg px-3.5 text-sm font-semibold border border-gray-300 bg-white hover:bg-gray-50" onClick={closeEdit}>취소</button>
              <button type="button" className="h-9 rounded-lg px-3.5 text-sm font-semibold bg-primary-600 text-white hover:bg-primary-700" onClick={handleSave}>저장</button>
            </div>
          </div>
        </div>
      )}

      {isCreateOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="absolute inset-0 bg-black/40" onClick={closeCreate} />
          <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4">
            <div className="px-6 pt-5 pb-3">
              <div className="text-[17px] font-bold">거래처 추가</div>
            </div>
            <div className="px-6 py-4 grid grid-cols-1 gap-4">
              <div>
                <label className="block text-[13px] font-semibold text-gray-600 mb-1">거래처명</label>
                <input name="거래처명" value={form.거래처명} onChange={handleChange} maxLength={40} className="w-full h-9 rounded-lg border border-gray-300 bg-white px-2.5 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 outline-none" />
              </div>
              <div>
                <label className="block text-[13px] font-semibold text-gray-600 mb-1">담당자</label>
                <input name="담당자" value={form.담당자} onChange={handleChange} maxLength={40} className="w-full h-9 rounded-lg border border-gray-300 bg-white px-2.5 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 outline-none" />
              </div>
              <div>
                <label className="block text-[13px] font-semibold text-gray-600 mb-1">이메일</label>
                <input name="대표이메일" type="email" value={form.대표이메일} onChange={handleChange} className="w-full h-9 rounded-lg border border-gray-300 bg-white px-2.5 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 outline-none" />
              </div>
            </div>
            <div className="px-6 pb-5 pt-3 flex justify-end gap-2">
              <button type="button" className="h-9 rounded-lg px-3.5 text-sm font-semibold border border-gray-300 bg-white hover:bg-gray-50" onClick={closeCreate}>취소</button>
              <button type="button" className="h-9 rounded-lg px-3.5 text-sm font-semibold bg-primary-600 text-white hover:bg-primary-700" onClick={handleCreate}>저장</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PartnerManagement;
